import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Sparkles, Mail, Clock, ShieldX } from "lucide-react";
import { invitationsApi } from "@/lib/api";
import { login } from "@/context/AuthContext";
import { ROLE_LABELS } from "@/lib/permissions";

export default function Invite() {
  const { token } = useParams();
  const [inv, setInv] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    invitationsApi.get(token).then(setInv).catch(() => setError(true));
  }, [token]);

  const invalid = error || (inv && inv.status !== "pending");
  const title = error ? "Invitation not found" : inv?.status === "expired" ? "Invitation expired" : inv?.status === "accepted" ? "Invitation already used" : "Invitation unavailable";

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-6 text-center" data-testid="invite-page">
      <span className={`flex h-16 w-16 items-center justify-center rounded-full ${invalid ? "bg-red-100 text-red-700" : "bg-primary text-gold"}`}>
        {invalid ? <ShieldX className="h-8 w-8" /> : <Sparkles className="h-8 w-8" />}
      </span>
      {!inv && !error ? (
        <div className="mt-6 h-6 w-6 animate-spin rounded-full border-2 border-gold border-t-transparent" />
      ) : invalid ? (
        <>
          <h1 className="mt-6 font-serif text-3xl font-semibold" data-testid="invite-invalid-title">{title}</h1>
          <p className="mt-3 max-w-md text-muted-foreground">Please ask a Godinga administrator to send you a new invitation.</p>
        </>
      ) : (
        <>
          <p className="eyebrow mt-6 text-gold">Team invitation</p>
          <h1 className="mt-2 font-serif text-3xl font-semibold sm:text-4xl" data-testid="invite-title">Join the Godinga team</h1>
          <p className="mt-3 max-w-md text-muted-foreground">
            {inv.invited_by} invited you as <strong className="text-foreground" data-testid="invite-role">{ROLE_LABELS[inv.role]}</strong>.
            Sign in with the Google account below to accept.
          </p>
          <div className="mt-6 flex items-center gap-2 rounded-full border border-border bg-card px-4 py-2 text-sm" data-testid="invite-email">
            <Mail className="h-4 w-4 text-gold" /> {inv.email}
          </div>
          <button onClick={login} data-testid="invite-accept-btn" className="mt-6 rounded-full bg-primary px-8 py-3 text-sm font-semibold text-primary-foreground transition-transform hover:-translate-y-0.5">
            Continue with Google
          </button>
          <p className="mt-4 inline-flex items-center gap-1.5 text-xs text-muted-foreground">
            <Clock className="h-3.5 w-3.5" /> Expires {new Date(inv.expires_at).toLocaleString()}
          </p>
        </>
      )}
    </div>
  );
}
